import { render, staticRenderFns } from "./appointmentList.vue?vue&type=template&id=2bee7624&scoped=true&"
import script from "./appointmentList.vue?vue&type=script&lang=js&"
export * from "./appointmentList.vue?vue&type=script&lang=js&"
import style0 from "./appointmentList.vue?vue&type=style&index=0&id=2bee7624&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bee7624",
  null
  
)

export default component.exports